/**
 *@台湾
 *@params
 *@author WangPing
 *@date 2020-07-20
 */

export default {
  _not_interested_in_this_video: '當前視頻不感興趣嗎？ %second%',
  _switch_one: '換一個',
  _next_reward_text: '再看壹個視頻獲得',
  _next_reward_button: '立即觀看',
  _just_for_you: '猜你喜歡',
}